import React from "react";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { Row, Col } from "react-bootstrap";
import { FaLinkedinIn } from "react-icons/fa";
import {
  SiLeetcode,
  SiHackerrank,
  SiCodechef,
  SiGmail,
  SiCodeforces,
  SiDiscord,
} from "react-icons/si";
import Particle from "../Particle";
export default function Contact() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        height: "99vh",
        maxWidth: "98vw",
        paddingTop: "80px",
      }}
    >
      <Particle />

      <Row>
        <Col md={12} className="home-about-social">
          <h1>Coding Profiles</h1>
          <ul className="home-about-social-links">
            <li className="social-icons">
              <a
                href="https://github.com/suraj719"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://leetcode.com/u/suraj719/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <SiLeetcode />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.hackerrank.com/profile/suraj719"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <SiHackerrank />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.codechef.com/users/suraj712"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <SiCodechef />
              </a>
            </li>
            {/* <li className="social-icons">
              <a
                href="https://codeforces.com/profile/suraj719"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <SiCodeforces />
              </a>
            </li> */}
          </ul>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="home-about-social">
          <h1>Social Profiles</h1>
          <ul className="home-about-social-links">
            <li className="social-icons">
              <a
                href="mailto:suraj963719@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <SiGmail />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/0xsuraj719"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <AiOutlineTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/surajthammi/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/suraj__712"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <AiFillInstagram />
              </a>
            </li>
            {/* <li className="social-icons">
              <a
                href="https://www.instagram.com/suraj__712"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <SiDiscord />
              </a>
            </li> */}
          </ul>
        </Col>
      </Row>
    </div>
  );
}
